
import {
    ADD_BANNER_REQUEST,
    ADD_BANNER_SUCCESS,
    ADD_BANNER_FAILURE,
    FETCH_BANNERS_REQUEST,
    FETCH_BANNERS_SUCCESS,
    FETCH_BANNERS_FAILURE,
    DELETE_BANNER_REQUEST,
    DELETE_BANNER_SUCCESS,
    DELETE_BANNER_FAILURE,
  } from "../actions/bannerActions";
  
  const initialState = {
    banners: {
      topBanners: [],
      midBanners: [],
      bottomBanners: [],
    },
    loading: false,
    error: null,
  };
  
  const bannerReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_BANNERS_REQUEST:
      case ADD_BANNER_REQUEST:
      case DELETE_BANNER_REQUEST:
        return { ...state, loading: true, error: null };
  
      case FETCH_BANNERS_SUCCESS:
        return { ...state, loading: false, banners: action.payload };
  
      case ADD_BANNER_SUCCESS:
        return { ...state, loading: false };

    case DELETE_BANNER_SUCCESS:
  // Destructure the bannerId and bannerType from action.payload
  const { bannerId, bannerType } = action.payload;

  // Ensure the array is defined and filter out the deleted banner
  return {
    ...state,
    loading: false,
    banners: {
      ...state.banners,
      [bannerType]: state.banners[bannerType] ? state.banners[bannerType].filter(banner => banner.id !== bannerId) : [],
    },
  };
  
      case FETCH_BANNERS_FAILURE:
      case ADD_BANNER_FAILURE:
      case DELETE_BANNER_FAILURE:
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export default bannerReducer;
  